import { coreApi } from '@modules/core/api';
import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useGetBrokerProfile = (authenticatorId?: string) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['brokerProfile', authenticatorId],
    queryFn: () => coreApi.getBrokerByAuthenticatorId(authenticatorId!),
    staleTime: Number.POSITIVE_INFINITY,
    enabled: !!authenticatorId,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetBrokerProfile;
